import React from 'react'
import PropTypes from 'prop-types'

import Button from 'components/Button'
import Displayer from 'components/Displayer'
import TeleHealthVideoContainer from 'containers/TeleHealthVideo/TeleHealthVideoContainer'

import { TeleHealthAppointmentStatus } from 'lib/constants'
import timeHelper from 'lib/timeHelper'
import FontAwesome from 'react-fontawesome'

import 'components/TeleHealth/TeleHealth.css'
import { AvVideocamOff, AvVideocam, AvMic, AvMicOff } from 'material-ui/svg-icons'


//Change for testing
const isDevTesting = false
let status = null

class TeleHealthUpperScreen extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         callCommand: false,
         publisherAudio: true,
         publisherVideo: true,
      };
      this.onStartCall = this.onStartCall.bind(this)
      this.onEndCall = this.onEndCall.bind(this)
      this.onChangePublisherAudio = this.onChangePublisherAudio.bind(this)
      this.onChangePublisherVideo = this.onChangePublisherVideo.bind(this)

      this.isCredentials = this.isCredentials.bind(this)
      this.isCredentialsOK = this.isCredentialsOK.bind(this)
      this.showVideoContainer = this.showVideoContainer.bind(this)
      this.showInfoMessage = this.showInfoMessage.bind(this)
      this.getInfoMessage = this.getInfoMessage.bind(this)

      this.getInfoMessageStyle = this.getInfoMessageStyle.bind(this)
      this.getTeleHealthVideoContainerStyle = this.getTeleHealthVideoContainerStyle.bind(this)
      this.getTeleHealthUpperScreenStyle = this.getTeleHealthUpperScreenStyle.bind(this)
      this.getAudioButtonClass = this.getAudioButtonClass.bind(this)
      this.getVideoButtonClass = this.getVideoButtonClass.bind(this)
      this.getAudioIconStyle = this.getAudioIconStyle.bind(this)
      this.getVideoIconStyle = this.getVideoIconStyle.bind(this)
   }

   onStartCall() {
      const { getAppointmentCredentials } = this.props
      getAppointmentCredentials()
      this.setState({ callCommand: true, publisherAudio: true, publisherVideo: true })
   }
   onEndCall() {
      const { resetPublisherSubscriberStatus } = this.props
      this.setState({ callCommand: false })
      resetPublisherSubscriberStatus()
   }
   onChangePublisherAudio(status) {
      this.setState({ publisherAudio: status })
   }
   onChangePublisherVideo(status) {
      this.setState({ publisherVideo: status })
   }

   /**************************************/
   /********** Helper functions **********/
   /**************************************/

   isCredentials() {
      const { teleHealthAppointmentCredentials } = this.props
      if (teleHealthAppointmentCredentials) { return true } else { return false }
      return false
   }
   isCredentialsOK() {
      const { teleHealthAppointmentCredentials } = this.props

      if (this.isCredentials()) {
         if (teleHealthAppointmentCredentials.status === 200) {
            return true
         } else {
            return false
         }
      } else {
         return false
      }
   }
   showVideoContainer() {
      const { teleHealthAppointmentCredentials } = this.props

      if (this.isCredentialsOK()) {
         if (teleHealthAppointmentCredentials.credentials.status === TeleHealthAppointmentStatus.WaitForDoctor ||
            teleHealthAppointmentCredentials.credentials.status === TeleHealthAppointmentStatus.WaitForClient ||
            teleHealthAppointmentCredentials.credentials.status === TeleHealthAppointmentStatus.InProgress) {
            return true
         } else {
            return false
         }
      } else {
         return false
      }
   }
   showInfoMessage() {
      const { teleHealthAppointmentCredentials, isSubscriber } = this.props

      if (this.isCredentialsOK() && !isSubscriber) {
         return true
      } else {
         return false
      }
   }
   getInfoMessage() {
      const { teleHealthAppointmentCredentials, appointment } = this.props
      const { dtoReservedAppointment: reservedAppointment, appointmentTime } = appointment
      const { clientFullName } = reservedAppointment
      // const gender = appointment.dtoProfessional.professionalGender === 'male' ? 'dr.' : 'dra.'
      const appointmentTimeFormatted = timeHelper.hourFromMinutes(appointment.appointmentTime)
      const appointmentTimeBefore = timeHelper.hourFromMinutes(appointment.appointmentTime-10)

      switch (teleHealthAppointmentCredentials.credentials.status) {
         case TeleHealthAppointmentStatus.Completed:
            return "Essa consulta já foi finalizada!"

         case TeleHealthAppointmentStatus.Rescheduled:
            return "Essa consulta foi reagendada!"

         case TeleHealthAppointmentStatus.PaymentPending:
            return "Realize o pagamento para liberar o acesso a essa consulta!"

         case TeleHealthAppointmentStatus.Canceled:
            return "Essa consulta foi cancelada!"

         case TeleHealthAppointmentStatus.BeforeTime:
            return `Essa consulta estará disponível 10 minutos antes do horário marcado (${appointmentTimeFormatted}).\nTente novamente às ${appointmentTimeBefore}`

         case TeleHealthAppointmentStatus.ExpiredTime:
            return "Essa consulta não está mais disponível!"

         // case TeleHealthAppointmentStatus.WaitForDoctor:
         //     return `Aguardando ${gender} ${appointment.dtoProfessional.fullName} entrar na sala...`

         case TeleHealthAppointmentStatus.WaitForClient:
            return `Aguardando ${clientFullName} entrar na sala...`

         case TeleHealthAppointmentStatus.InProgress:
            return `Consulta em andamento...`

         default:
            return ""
      }
   }

   /**************************************/
   /********** Component styles **********/
   /**************************************/

   getInfoMessageStyle() {
      const { teleHealthAppointmentCredentials } = this.props
      let style = {
         paddingRight: 10,
         paddingLeft: 10,
         paddingBottom: 15,
         whiteSpace: 'pre-wrap',
         color: 'rgb(29,159,173)',
         fontWeight: 'bold',
      }
      switch (teleHealthAppointmentCredentials.credentials.status) {
         case TeleHealthAppointmentStatus.Completed:
         case TeleHealthAppointmentStatus.Rescheduled:
         case TeleHealthAppointmentStatus.PaymentPending:
         case TeleHealthAppointmentStatus.Canceled:
         case TeleHealthAppointmentStatus.ExpiredTime:
            style = {
               ...style,
               color: 'rgb(238,141,35)',
            }
            return style

         case TeleHealthAppointmentStatus.BeforeTime:
         case TeleHealthAppointmentStatus.WaitForDoctor:
         case TeleHealthAppointmentStatus.WaitForClient:
         case TeleHealthAppointmentStatus.InProgress:
            style = {
               ...style,
               color: 'rgb(159,198,85)',
            }
            return style
         default:
            return style
      }
   }
   getTeleHealthUpperScreenStyle() {
      const { isSubscriber } = this.props
      let style = {}
      if (isSubscriber) {
         style = { height: "calc(100% - 10px)", width: "calc(100% - 10px)", position: 'absolute' }
      } else {
         style = null
      }
      return style
   }
   getTeleHealthVideoContainerStyle() {
      const { isSubscriber } = this.props
      let style = {}
      if (!isSubscriber) {
         style = {
            height: 0,
            paddingBottom: 'calc((9 / 16) * 100%)',
            position: 'relative',
            marginBottom: '15px',
         }
      } else {
         style = {
            height: "100%",
            width: "100%",
            position: 'relative',
         }
      }
      return style;
   }

   getAudioButtonClass() {
      let audioButtonClass = 'botaoAudio child'
      this.state.publisherAudio ? audioButtonClass = 'botaoAudio child' : audioButtonClass = 'botaoAudio child audioButtonDisabled'
      return audioButtonClass
   }
   getVideoButtonClass() {
      let videoButtonClass = 'botaoVideo child'
      this.state.publisherVideo ? videoButtonClass = 'botaoVideo child' : videoButtonClass = 'botaoVideo child videoButtonDisabled'
      return videoButtonClass
   }

   getAudioIconStyle() {
      let audioIconStyle = {
         color: 'rgba(131,131,131,0.8)',
         position:'absolute',
         /* top:0px;
         left:0px; */
         height: '22px',
         top:'calc(50%)',
         left:'calc(50%)',
         transform: 'translate(-50%, -50%)',
      }

      if(this.state.publisherAudio){
         return audioIconStyle
      } else {
         audioIconStyle = {...audioIconStyle, color: 'rgba(255,255,255,0.8)'}
      }
      return audioIconStyle
   }
   getVideoIconStyle() {
      let videoIconStyle = {
         color: 'rgba(131,131,131,0.8)',
         position:'absolute',
         /* top:0px;
         left:0px; */
         height: '22px',
         top:'calc(50%)',
         left:'calc(50%)',
         transform: 'translate(-50%, -50%)',
      }

      if(this.state.publisherVideo){
         return videoIconStyle
      } else {
         videoIconStyle = {...videoIconStyle, color: 'rgba(255,255,255,0.8)'}
      }
      return videoIconStyle
   }


   render() {

      const { appointment, ui, teleHealthAppointmentCredentials,
              changePublisherStatus, changeSubscriberStatus, isPublisher, isSubscriber,
              clearTelehealthAppointmentCredentials } = this.props

      // if (isDevTesting) {
      //    if (teleHealthAppointmentCredentials) {
      //       status = 'wait_for_client'
      //       teleHealthAppointmentCredentials.credentials.status = status
      //       teleHealthAppointmentCredentials.credentials.apiKey = "46262392"
      //       teleHealthAppointmentCredentials.credentials.sessionId = "1_MX40NjI2MjM5Mn5-MTU4NzMzNTgzNDY4Mn5rd0x6VnhBTVVNL3Bzb1RLQmxFclZDcWx-fg"
      //       teleHealthAppointmentCredentials.credentials.token = "T1==cGFydG5lcl9pZD00NjI2MjM5MiZzaWc9OGZjOTRmMjNkYTU0NzYzYmMxNWI4MWE4NDY1YWEwYjEyNzYzZTgxZTpzZXNzaW9uX2lkPTFfTVg0ME5qSTJNak01TW41LU1UVTROek16TlRnek5EWTRNbjVyZDB4NlZuaEJUVlZOTDNCemIxUkxRbXhGY2xaRGNXeC1mZyZjcmVhdGVfdGltZT0xNTkwNDk2Mjg5Jm5vbmNlPTAuOTg2MzA2MzIwNTEzODgzNiZyb2xlPXB1Ymxpc2hlciZleHBpcmVfdGltZT0xNTkwNTE3ODg4JmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9"
      //    }
      // }
      const showVideoContainer = this.state.callCommand && this.showVideoContainer()
      const isInfoMessage = this.state.callCommand && this.showInfoMessage()

      return (

         <div className='TeleHealthUpperScreen' style={this.getTeleHealthUpperScreenStyle()}>

            {showVideoContainer ?
               <div style={{ height: "100%", width: "100%" }}>
                  <div className="TeleHealthVideoContainer" style={this.getTeleHealthVideoContainerStyle()}>
                     <TeleHealthVideoContainer
                        appointment={appointment}
                        apiKey={teleHealthAppointmentCredentials.credentials.apiKey}
                        sessionId={teleHealthAppointmentCredentials.credentials.sessionId}
                        token={teleHealthAppointmentCredentials.credentials.token}
                        changePublisherStatus={changePublisherStatus}
                        changeSubscriberStatus={changeSubscriberStatus}
                        isPublisher={isPublisher}
                        isSubscriber={isSubscriber}
                        publisherAudio={this.state.publisherAudio}
                        publisherVideo={this.state.publisherVideo}
                        clearTelehealthAppointmentCredentials={clearTelehealthAppointmentCredentials}
                     />
                  </div>
                  {!isInfoMessage ? null :
                     <Displayer status={ui.teleHealthAppointmentCredentials}>
                        <div style={this.getInfoMessageStyle()}> {this.getInfoMessage()} </div>
                     </Displayer>
                  }
                  {isSubscriber ?
                     <div className='granparent'>
                        <div className='parent'>

                           <div className={this.getVideoButtonClass()} onClick={() => { this.onChangePublisherVideo(!this.state.publisherVideo) }}>
                              {this.state.publisherVideo ?
                                 <AvVideocam className='videoIcone' style={this.getVideoIconStyle()}></AvVideocam>
                                 :
                                 <AvVideocamOff className='videoIcone videoIconeDisabled' style={this.getVideoIconStyle()}></AvVideocamOff>
                              }
                           </div>

                           <div className='botaoDesligar child' onClick={this.onEndCall}>
                              <FontAwesome className='desligarIcone' name='phone' />
                           </div>

                           <div className={this.getAudioButtonClass()} onClick={() => { this.onChangePublisherAudio(!this.state.publisherAudio) }}>
                              {this.state.publisherAudio ?
                                 <AvMic className='audioIcone' style={this.getAudioIconStyle()}></AvMic>
                                 :
                                 <AvMicOff className='audioIcone audioIconeDisabled'  style={this.getAudioIconStyle()}></AvMicOff>
                              }
                           </div>

                        </div>
                     </div>
                     :
                     <Button
                        label="Encerrar"
                        secondary
                        onClick={this.onEndCall}
                     />
                  }
               </div>
               :
               <div>
                  <Displayer status={ui.teleHealthAppointmentCredentials}>
                     {isInfoMessage ? <div style={this.getInfoMessageStyle()}> {this.getInfoMessage()} </div> : ""}
                  </Displayer>
                  <Button
                     style={{margin : '20px'}}
                     label="Iniciar consulta"
                     primary
                     onClick={this.onStartCall}
                  />
               </div>
            }

         </div>
      )
   }
}

TeleHealthUpperScreen.propTypes = {
   appointment: PropTypes.object.isRequired,
   ui: PropTypes.object.isRequired,
   getAppointmentCredentials: PropTypes.func.isRequired,
   resetPublisherSubscriberStatus: PropTypes.func.isRequired,
   changePublisherStatus: PropTypes.func.isRequired,
   changeSubscriberStatus: PropTypes.func.isRequired,
   isPublisher: PropTypes.bool.isRequired,
   isSubscriber: PropTypes.bool.isRequired,
   clearTelehealthAppointmentCredentials: PropTypes.func.isRequired
}

export default TeleHealthUpperScreen


// WEBPACK FOOTER //
// ./src/components/TeleHealth/TeleHealthUpperScreen.js